<template>
	<div class="wrapper" @click="toggleCheck">
		<div class="info">
			<ui-image :src="getImgCDN(customer.avatar)" design="circle border-lg" h="45" w="45" />
		</div>
		<div class="info">
			<div class="name">
				{{ validateData(customer.name, 'name') }}
			</div>
			<div class="other">
				<em class="fal fa-envelope"></em> {{ validateData(customer.email, 'email') }}
			</div>
			<div class="other">
				<em class="fal fa-mobile-alt"></em> {{ validateData(formatPhoneNew(customer.customer_country_code_mobile, customer.customer_mobile), 'mobile') }}
			</div>
			<div class="other">
				<em class="fal fa-phone-alt"></em> {{ validateData(formatPhoneNew(customer.customer_country_code_phone, customer.customer_phone), 'phone') }}
			</div>
			<div class="other" v-if="customer.type == 'Pessoa Fisica'">
				<em class="fal fa-address-card"></em> {{ validateData(customer.cpf, 'cpf') }}
			</div>
			<div class="other" v-else>
				<em class="fal fa-address-card"></em> {{ validateData(customer.cnpj, 'cnpj') }}
			</div>
		</div>
		<div class="circle-check" :class="checkboxClass">
			<em v-show="check" class="fal fa-check"></em>
		</div>
	</div>
</template>

<script>
	import { uiImage } from '@/components/ui'
	import { helpersMixin, maskIntl } from '@/mixins'

	export default {
		name: 'action-wrapper-item',

		components: {
			uiImage,
		},

		props: {
			customer: {
				type: Object,
				required: true,
			},

			checked: {
				type: Boolean,
				required: true,
			},

			value: {
				type: Number,
				required: true,
			},
		},

		mixins: [helpersMixin, maskIntl],

		data() {
			return {
				check: false,
			}
		},

		methods: {
			toggleCheck() {
				if (!this.check) {
					this.$emit('input', this.customer.id_customer)
					return
				}

				this.$emit('input', -1)
			},

			validateData(data, type) {
				const toReturn = !data || data == '' ? 'Não informado' : data

				if (toReturn != 'Não informado' && type == 'cpf')
					return this.maskValues.maskCPF(toReturn)
				if (toReturn != 'Não informado' && type == 'cnpj')
					return this.maskValues.maskCNPJ(toReturn)

				return toReturn
			},
		},

		computed: {
			checkboxClass() {
				return {
					active: this.check,
				}
			},

			/**
			 * Retorna um object com mask functions
			 * @returns {Object}
			 */
			maskValues() {
				return {
					/**
					 * @param {String} toMask
					 * @returns {String} Retorna uma string mascarada em CPF
					 */
					maskCPF(toMask) {
						return toMask
							.replace(/\D/g, '')
							.replace(/(\d{3})(\d)/, '$1.$2')
							.replace(/(\d{3})(\d)/, '$1.$2')
							.replace(/(\d{3})(\d{1,2})/, '$1-$2')
							.replace(/(-\d{2})\d+?$/, '$1')
					},

					/**
					 * @param {String} toMask
					 * @returns {String} Retorna uma string mascarada em CNPJ
					 */
					maskCNPJ(toMask) {
						return toMask
							.replace(/\D/g, '')
							.replace(/(\d{2})(\d)/, '$1.$2')
							.replace(/(\d{3})(\d)/, '$1.$2')
							.replace(/(\d{3})(\d)/, '$1/$2')
							.replace(/(\d{4})(\d{2})/, '$1-$2')
					},

					/**
					 * @param {String} toMask
					 * @returns {String} Retorna uma string mascarada em Phone
					 */
					maskPhone(toMask) {
						return toMask
							.replace(/\D/g, '')
							.replace(/(\d{2})(\d)/, '($1) $2')
							.replace(/(\d{5})(\d{4})/, '$1-$2')
					},

					/**
					 * @param {String} toMask
					 * @returns {String} Retorna uma string mascarada em Mobile
					 */
					maskMobile(toMask) {
						return toMask
							.replace(/\D/g, '')
							.replace(/(\d{2})(\d)/, '($1) $2')
							.replace(/(\d{4})(\d{4})/, '$1-$2')
					},
				}
			},
		},

		watch: {
			checked(value) {
				this.check = value
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
